// extracted by mini-css-extract-plugin
module.exports = {"label":"Upload_label__yAGc5","footer":"Upload_footer__1Jh4m"};